module.exports = __webpack_public_path__ + "static/media/propheticdeclarations.6ae1ce4a.png";